import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

import { HookFormInputGroup } from "components";
import {
	floatWithComma2Normalizer,
	commaAndFloat2Normalizer,
} from "validators";

import styles from "./posSubscriptionSection.module.scss";

type FooterProps = {
	sectionName: string;
	register: UseFormRegister<any>;
	errors: FieldErrors<any>;
	isLoading?: boolean;
	totalPrice: number | string | undefined | null;
};

const Footer = ({
	sectionName,
	isLoading = false,
	register,
	errors,
	totalPrice,
}: FooterProps) => {
	const discountName = `${sectionName}.subscriptions.discount`;

	return (
		<>
			<tr className={styles.tableFooter}>
				<td className={styles.emptyColumn}></td>
				<td colSpan={3}>Discount</td>
				<td colSpan={3}>
					<HookFormInputGroup
						name={discountName}
						register={register}
						colInput={12}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder=""
						normalizeOnBlur={floatWithComma2Normalizer}
						normalize={commaAndFloat2Normalizer}
						solveCaretIssue={commaAndFloat2Normalizer}
						errors={errors}
						inputBlockClassName={styles.costInput}
						className="form-group-mb-0"
					/>
				</td>
				<td className={styles.emptyColumn}></td>
			</tr>
			<tr>
				<th className={styles.emptyColumn}></th>
				<th colSpan={3}>Total Price</th>
				<th colSpan={3}>
					{floatWithComma2Normalizer(totalPrice, "$")}
				</th>
				<th className={styles.emptyColumn}></th>
			</tr>
		</>
	);
};

export default Footer;
